import { useState, useEffect, ReactNode } from 'react'
import Text, { Props as TextProps } from '../Text'

export interface Props extends TextProps {
  children: ReactNode
}

const FUNNY_MESSAGES = [
  'Okay this is taking a bit',
  "It's gonna be worth it trust me",
  'So how was your weekend?',
]

const DOT_INTERVAL_MS = 500
const MAX_DOTS = 3
const MESSAGE_CHANGE_INTERVAL_MS = 6_000

export default function LoadingText({ children, ...textProps }: Props) {
  const [dotCount, setDotCount] = useState(0)
  const [elapsedTime, setElapsedTime] = useState(0)
  const [funnyMessageIndex, setFunnyMessageIndex] = useState(-1)

  useEffect(() => {
    const dotTimer = setInterval(() => {
      setDotCount((prev) => (prev + 1) % (MAX_DOTS + 1))
    }, DOT_INTERVAL_MS)

    return () => clearInterval(dotTimer)
  }, [])

  useEffect(() => {
    const timeTracker = setInterval(() => {
      setElapsedTime((prev) => prev + MESSAGE_CHANGE_INTERVAL_MS)
    }, MESSAGE_CHANGE_INTERVAL_MS)

    return () => clearInterval(timeTracker)
  }, [])

  useEffect(() => {
    if (elapsedTime >= MESSAGE_CHANGE_INTERVAL_MS) {
      const messageIndex =
        Math.floor(elapsedTime / MESSAGE_CHANGE_INTERVAL_MS) - 1
      if (messageIndex < FUNNY_MESSAGES.length) {
        setFunnyMessageIndex(messageIndex)
      }
    }
  }, [elapsedTime])

  const displayMessage =
    funnyMessageIndex >= 0 ? FUNNY_MESSAGES[funnyMessageIndex] : children
  const dots = '.'.repeat(dotCount)

  return (
    <Text {...textProps}>
      {displayMessage}
      {dots}
    </Text>
  )
}
